import axiosInstance from "../../../utils/axiosConfig";
import type { IsoDateRange } from "../../../lib/adminExport/datePresets";
import type { PayrollStaffRecord } from "./payrollStaffTable";

/**
 * The payroll staff endpoint returns a flat array (no pagination or date
 * params), so we fetch once and filter by `createdAt` client-side when a range
 * is chosen.
 */
export async function fetchPayrollStaffForExport(
  range?: IsoDateRange | null
): Promise<PayrollStaffRecord[]> {
  const { data } = await axiosInstance.get<{ data?: unknown }>(
    "api/payroll/staff"
  );
  const all: PayrollStaffRecord[] = Array.isArray(data?.data)
    ? (data.data as PayrollStaffRecord[])
    : [];

  if (!range) return all;

  const start = new Date(`${range.startDate}T00:00:00`).getTime();
  const end = new Date(`${range.endDate}T23:59:59`).getTime();

  return all.filter((staff) => {
    const created = new Date(String(staff.createdAt)).getTime();
    if (Number.isNaN(created)) return false;
    return created >= start && created <= end;
  });
}
